import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const addLangModalSelector = createSelector(modalsSelector, (modals) => modals.addLang);

export default addLangModalSelector;
